import { Filter } from '@anytag/shared-molecules';
import { useAccountsFilter } from './hooks';
import { Template, TemplateProps } from './Template';

export type AccountsFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const AccountsFilter = (props: AccountsFilterProps) => {
  const { filter, setFilterForm } = useAccountsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template {...props} />
    </Filter.Provider>
  );
};

export { useAccountsFilter };
export * from './schemaTypes';
